import {getElementFromLocalStorage, setElementToLocalStorage} from 'app/helpers/webStorageUtility';

const LAST_VIEWED_SCENES_STORE = 'lastVideos';
export const LAST_VIDEOS_STORE_DURATION = 172800000;

export const getLastViewedVideos = () => {
  const lastViewedVideos = getElementFromLocalStorage(LAST_VIEWED_SCENES_STORE);
  return lastViewedVideos ? JSON.parse(lastViewedVideos) : null;
};

export const setLastViewedVideos = value => {
  const newValue = typeof value === 'string' ? value : JSON.stringify(value);
  setElementToLocalStorage(LAST_VIEWED_SCENES_STORE, newValue);
};

export const getRedirectVideo = playlist => {
  const lastViewedScenes = getLastViewedVideos();
  const firstPlaylistVideo = playlist[0];
  if (lastViewedScenes) {
    const savedState = lastViewedScenes.find(playlist => playlist.id === firstPlaylistVideo.matchPlaylistId);
    // only to saved index if set and there are videos after this one
    return savedState && savedState.videoIndex < playlist.length - 1
      ? playlist[savedState.videoIndex]
      : firstPlaylistVideo;
  } else {
    return firstPlaylistVideo;
  }
};

export const checkForUnwatchedVideo = (teaserObject, videosCount) => {
  const {updatedAt, data, type} = teaserObject;
  const updatedAtMs = updatedAt * 1000;
  const checkDate = updatedAtMs + LAST_VIDEOS_STORE_DURATION;
  const nowTimestamp = new Date().getTime();
  // only true if playlist was updated within 2 days
  if (checkDate < nowTimestamp) {
    return false;
  } else {
    const lastViewedScenes = getLastViewedVideos();
    const storageId = type === 'embed' ? `embed_${data.id}` : data.id;
    const savedPlaylistIndex = lastViewedScenes
      ? lastViewedScenes.indexOf(lastViewedScenes.find(playlist => playlist.id === storageId))
      : -1;
    if (savedPlaylistIndex < 0) {
      // if not saved, its updated
      return true;
    } else {
      // if playlist (videos-count set), check if there are more videos than viewed
      // if embed (no videosCount), its already watched
      return videosCount ? lastViewedScenes[savedPlaylistIndex].videoIndex < videosCount - 1 : false;
    }
  }
};

export const updateLastViewed = (playlistId, videoIndex) => {
  if (videoIndex < 0) {
    return;
  }
  const lastViewedScenes = getLastViewedVideos();
  let updatedStore = [];
  const currentTimestamp = new Date().getTime();
  const newValue = {id: playlistId, videoIndex, expiry: currentTimestamp + LAST_VIDEOS_STORE_DURATION};

  if (!lastViewedScenes) {
    // if the item doesn't exist, create it from scratch
    updatedStore.push(newValue);
  } else {
    // remove outdated data
    const filteredLastViewedScenes = lastViewedScenes.filter(playlist => !(currentTimestamp > playlist.expiry));
    const savedPlaylistIndex = filteredLastViewedScenes.indexOf(
      filteredLastViewedScenes.find(playlist => playlist.id === playlistId)
    );
    if (savedPlaylistIndex >= 0) {
      // if playlist already saved update current value
      const updateValue = newValue;
      if (filteredLastViewedScenes[savedPlaylistIndex].videoIndex > updateValue.videoIndex) {
        updateValue.videoIndex = filteredLastViewedScenes[savedPlaylistIndex].videoIndex;
      }
      filteredLastViewedScenes[savedPlaylistIndex] = updateValue;
      updatedStore = filteredLastViewedScenes;
    } else {
      // else add playlist
      filteredLastViewedScenes.push(newValue);
      updatedStore = filteredLastViewedScenes;
    }
  }
  setLastViewedVideos(updatedStore);
};
